if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    connectedCallback() {
      this.cards     = this.querySelectorAll('.pbu-card');
      this.totalEl   = this.querySelector('.product-bundle__total-price');
      this.compareEl = this.querySelector('.product-bundle__compare-price');
      this.savingsEl = this.querySelector('.product-bundle__savings');
      this.percentEl = this.querySelector('.product-bundle__percent-off');
      this.addBtn    = this.querySelector('.product-bundle__add-btn');
      this.btnText   = this.querySelector('.btn-text');
      this.manualDiscount = parseInt(this.dataset.manualDiscount || 0);

      // Reference the theme's cart drawer / cart notification
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.cards.forEach(card => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('a')) return;
          const cb = card.querySelector('.product-bundle__checkbox');
          if (!cb) return;
          cb.checked = !cb.checked;
          card.classList.toggle('is-checked', cb.checked);
          this.update();
        });
      });

      this.addBtn?.addEventListener('click', () => this.addToCart());
      this.update();
    }

    update() {
      let total   = 0;
      let compare = 0;
      let count   = 0;

      this.cards.forEach(card => {
        const cb = card.querySelector('.product-bundle__checkbox');
        if (cb && cb.checked) {
          total   += parseInt(card.dataset.price   || 0);
          compare += parseInt(card.dataset.compare || card.dataset.price || 0);
          count++;
        }
      });

      // --- Compare price and savings ---
      const fullSum = total;
      if (this.manualDiscount > 0 && count > 0) {
        total = Math.max(0, fullSum - this.manualDiscount);
        compare = fullSum;
      }

      // --- Total price ---
      if (this.totalEl) this.totalEl.innerHTML = this.money(total);

      // --- Compare price ---
      if (this.compareEl) {
        if (compare > total) {
          this.compareEl.innerHTML = this.money(compare);
          this.compareEl.style.display = '';
        } else {
          this.compareEl.style.display = 'none';
        }
      }

      // --- Savings line ---
      const savings = compare - total;
      if (this.savingsEl) {
        if (savings > 0 && compare > 0) {
          const pct = Math.round((savings / compare) * 100);
          const amountEl = this.savingsEl.querySelector('.bundle-save-amount');
          if (amountEl) amountEl.innerHTML = this.money(savings);
          if (this.percentEl) this.percentEl.textContent = `(${pct}% off)`;
          this.savingsEl.style.display = 'flex';
        } else {
          this.savingsEl.style.display = 'none';
        }
      }

      // --- Button ---
      if (this.addBtn) {
        this.addBtn.disabled = count === 0;
        if (this.btnText) {
          this.btnText.textContent = count > 0
            ? `ADD ALL ${count} TO CART`
            : 'SELECT ITEMS';
        }
      }
    }

    money(cents) {
      // Use Shopify.formatMoney if available
      if (window.Shopify?.formatMoney) {
        const fmt = window.theme?.moneyFormat
          || document.querySelector('[data-money-format]')?.dataset?.moneyFormat
          || '₹{{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      
      // Better fallback for currency detection
      const existing = this.totalEl?.textContent?.trim() || '';
      let sym = '₹';
      // Match anything that isn't a digit, space, comma, or dot at the start or end
      const match = existing.match(/^[^\d\s,.]+/);
      if (match) {
        sym = match[0];
      } else {
        const matchEnd = existing.match(/[^\d\s,.]+$/);
        if (matchEnd) sym = matchEnd[0];
      }
      
      const formattedAmount = (cents / 100).toLocaleString('en-IN', { 
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      });
      
      return sym + ' ' + formattedAmount;
    }

    async addToCart() {
      const items = [];
      this.cards.forEach(card => {
        const cb = card.querySelector('.product-bundle__checkbox');
        if (cb && cb.checked && card.dataset.variantId) {
          items.push({ id: parseInt(card.dataset.variantId), quantity: 1 });
        }
      });
      if (!items.length) return;

      this.addBtn.disabled = true;
      this.addBtn.classList.add('is-loading');
      if (this.btnText) this.btnText.textContent = 'ADDING...';

      try {
        const sectionsToRender = this.cart?.getSectionsToRender?.() || [
          { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];

        const body = JSON.stringify({
          items,
          sections: sectionsToRender.map(s => s.section || s.id),
          sections_url: window.location.pathname
        });

        // Use the theme's native fetchConfig helper
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };

        const res = await fetch('/cart/add.js', { ...config, body });
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.description || 'Add to cart failed');
        }

        // Trigger theme events
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-bundle',
            cartData: data
          });
        }

        // Handle drawer display
        if (this.cart && typeof this.cart.renderContents === 'function') {
          if (this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          this.cart.renderContents(data);
        } else {
          window.location.href = '/cart';
        }

      } catch (err) {
        console.error('[ProductBundle] Error:', err);
        alert(err.message);
      } finally {
        this.addBtn.disabled = false;
        this.addBtn.classList.remove('is-loading');
        this.update();
      }
    }
  }

  customElements.define('product-bundle', ProductBundle);
}
